import renderStatusModal from "../status-modal";

import { CheckCircleWithShadow } from "../../../Assets/Icons";

export default function renderWelcomeToStakeSaver(modalContext, stakeSaverOffer) {
  const { onModalClose } = modalContext;

  renderStatusModal(modalContext, {
    StatusIcon: CheckCircleWithShadow,
    title: stakeSaverOffer?.check_out_details?.check_out_success_title,
    description: stakeSaverOffer?.check_out_details?.check_out_success_description,
    CTAButtonText: stakeSaverOffer?.check_out_details?.check_out_success_button_label,
    onCTAButtonClick: onModalClose,
  });
}
